import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  children: ReactNode;
  onClick?: () => void;
  className?: string;
}
export function CTAButton({
  children,
  onClick,
  className = ''
}: CTAButtonProps) {
  return <motion.button whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.98
  }} onClick={onClick} className={`bg-accent text-bg font-heading font-bold uppercase tracking-wider rounded-lg px-10 py-4 glow-green hover:glow-green-intense transition-all duration-300 ${className}`} data-id="element-204">
      {children}
    </motion.button>;
}